module.exports = __webpack_public_path__ + "static/media/Installation.a2850e47.md";